// A tiny event-based auth gate to request login from anywhere

const LOGIN_REQUIRED_EVENT = 'LOGIN_REQUIRED';

let pendingActionRef = null;

export function requestLogin(pendingAction, referral_code) {
  // pendingAction: optional function to be executed after successful login
  // referral_code: optional referral code for tracking
  pendingActionRef = typeof pendingAction === 'function' ? pendingAction : null;
  if (typeof window !== 'undefined') {
    const event = new CustomEvent(LOGIN_REQUIRED_EVENT, {
      detail: {
        pendingAction: pendingActionRef,
        referral_code: referral_code
      }
    });
    window.dispatchEvent(event);
  }
}

export function consumePendingAction() {
  const fn = pendingActionRef;
  pendingActionRef = null;
  return fn;
}

export const AUTH_GATE_EVENTS = {
  LOGIN_REQUIRED_EVENT,
};


